<template>
    <div class="baseSet">
        <h1>基本设置</h1>
        <a-form-model :model="form"
                      :rules="modleRules"
                      :label-col="labelCol"
                      :wrapper-col="wrapperCol"
                      ref="addForm"
                      class="baseForm">
            <a-row>
                <a-col :span="16">
                    <a-row>
                        <a-col :span="12">
                            <a-form-model-item label="游戏名称" ref="name" prop="name">
                                <a-input v-model="form.name" :maxLength="30"
                                         @change="e => form.name = e.target.value.replace(/\s*/g, '')"/>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item label="版本名称">
                                <a-input v-model="form.versionName" :maxLength="30" placeholder="请输入版本名称"/>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item label="适用性别" ref="applicableGender" prop="applicableGender">
                                <a-radio-group v-model="form.applicableGender">
                                    <a-radio :value="0">均可</a-radio>
                                    <a-radio :value="1">男</a-radio>
                                    <a-radio :value="2">女</a-radio>
                                </a-radio-group>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item label="适用年龄段" ref="minAge" prop="minAge">
                                <a-input-number v-model="form.minAge" type="number" :precision="0" :min="1" :max="150"/>
                                <em style="margin:0 5px;">-</em>
                                <a-input-number v-model="form.maxAge" type="number" :precision="0" :min="1" :max="150"/>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item label="最佳年龄" ref="optimumAge" prop="optimumAge">
                                <a-input-number v-model="form.optimumAge" type="number" :precision="0" :min="1" :max="100" style="width:100%;"/>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item label="信度">
                                <a-input v-model="form.reliability" :maxLength="30" placeholder="请输入"/>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item label="预计用时" ref="optimumAge">
                                <a-input-number v-model="form.minute" type="number" :precision="0" :min="0" :max="9999" style="width:25%;margin-right:15px;"/>
                                分
                                <a-input-number v-model="form.second" type="number" :precision="0" :min="0" :max="59" style="width:25%;margin:0 15px;"/>
                                秒
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item label="效度">
                                <a-input v-model="form.validity" :maxLength="30" placeholder="请输入"/>
                            </a-form-model-item>
                        </a-col>

                        <a-col :span="12" v-if="form.classifyTag == 4">
                            <a-form-model-item label="状态" ref="enabled" prop="enabled">
                                <!--10.26添加时候默认禁用且无法编辑，能力和版本列表为空时禁用-->
                                <a-switch :checked="form.enabled"
                                        @change="StatusChange"
                                        :disabled="$route.query.type === 'add' && !contentVersionId"/>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item label="课程体系">
                                <div>
                                    <template v-for="(tag, index) in tags" >
                                        <a-tag :key="tag" closable @close="() => handleClose(tag)">
                                            {{ tag }}
                                        </a-tag>
                                    </template>
                                    <a-input
                                        v-if="inputVisible"
                                        ref="input"
                                        type="text"
                                        size="small"
                                        :style="{ width: '78px' }"
                                        :value="inputValue"
                                        @change="handleInputChange"
                                        @blur="handleInputConfirm"
                                        @keyup.enter="handleInputConfirm"
                                        />
                                    <a-tag v-else style="background: #fff; borderStyle: dashed;" @click="showInput">
                                        <a-icon type="plus" /> 新增体系
                                    </a-tag>
                                </div>
                            </a-form-model-item>
                        </a-col>

                    </a-row>
                    <a-form-model-item label="设备要求" :label-col="{span: 3}" :wrapper-col="{span: 17}">
                        <a-checkbox-group v-model="form.hardwareRequirements">
                            <a-checkbox :value="item.id" v-for="item in hardwareList" :key="item.id">
                                {{ item.name }}
                            </a-checkbox>
                        </a-checkbox-group>
                    </a-form-model-item>

                    <a-form-model-item label="描述" :label-col="{span: 3}" :wrapper-col="{span: 17}">
                        <a-input :rows="4" v-model="form.description" type="textarea"/>
                    </a-form-model-item>
                    <a-form-model-item label="备注" :label-col="{span: 3}" :wrapper-col="{span: 17}">
                        <a-input :rows="4" v-model="form.remark" type="textarea"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="8">
                    <a-form-model-item label="Banner" ref="coverPlanUri" prop="coverPlanUri">
                        <div class="bannerUpload">
                            <a-upload
                                    name="imgFile"
                                    list-type="picture-card"
                                    class="avatar-uploader"
                                    :show-upload-list="false"
                                    :headers="headers"
                                    :action="baseURL"
                                    @change="changeBanner"
                                    :before-upload="beforeBanner"
                            >
                                <div v-if="form.coverPlanUri">
                                    <a-icon
                                            v-show="bimgLoading"
                                            style="position: absolute; top: 45%; left: 45%"
                                            type="loading"
                                    />
                                    <img style="width: 150px;height: 45px;object-fit: contain;" :src="form.coverPlanUri | filterUrl"
                                         alt="avatar">
                                </div>
                                <div v-else>
                                    <a-icon :type="bannerloading ? 'loading' : 'plus'"/>
                                </div>
                            </a-upload>
                        </div>
                    </a-form-model-item>
                    <a-form-model-item label="Icon"  style="margin-top: 70px;" prop="icon">
                        <div class="iconUpload">
                            <a-upload name="imgFile"
                                      list-type="picture-card"
                                      class="avatar-uploader"
                                      :show-upload-list="false"
                                      :headers="headers"
                                      :action="baseURL"
                                      @change="changeIcon"
                                      :before-upload="beforeIcon">
                                <div v-if="form.icon">
                                    <a-icon
                                            v-show="imgLoading"
                                            style="position: absolute; top: 45%; left: 45%"
                                            type="loading"/>
                                    <img style="width: 150px;height: 150px;object-fit: contain;" :src="form.icon | filterUrl"
                                         alt="avatar">
                                </div>
                                <div v-else>
                                    <a-icon :type="iconloading ? 'loading' : 'plus'"/>
                                </div>
                            </a-upload>
                        </div>
                    </a-form-model-item>
                </a-col>
            </a-row>

            <div style="text-align: center;">
                <a-button type="primary" @click="onSubmit" :disabled="subLoading">保存信息</a-button>
            </div>

        </a-form-model>
    </div>
</template>

<script>
import moment from "moment";
import Apis from "@/requests/apis";
    function getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener("load", () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    export default {
        name: "baseSet",
        props: ['pagetype'],
        data() {
            return {
                moment,
                labelCol: {span: 6},
                wrapperCol: {span: 16},
                form: {
                    name: "",
                    minAge: "",
                    maxAge: "",
                    description: "",
                    icon: "",
                    coverPlanUri: "",
                    classifyTag:1,
                    versionName: undefined,
                    enabled: false,
                    contentType: 1,
                    remark: '',
                    applicableGender:0,
                    optimumAge: undefined,
                    minute:'',
                    second:'',
                    estimatedTime:'',
                    hardwareRequirements:[],
                    reliability:undefined,
                    validity:undefined,
                    suitableCourses:[]
                },
                modleRules: {
                    name: [{required: true, message: "请填写游戏名称", trigger: "blur"}],
                    minAge: [{required: true, message: "请填写适用年龄段", trigger: "blur"}],
                    classifyTag: [{required: true, message: "请选择游戏类型", trigger: "change"}],
                    enabled: [{required: true, message: "请选择状态", trigger: "change"}],
                    icon: [{required: true, message: "请选择Icon", trigger: "blur"}],
                    coverPlanUri: [{required: true, message: "请选择Banner", trigger: "blur"}],
                    optimumAge: [{ required: true, message: "请填写最佳年龄", trigger: "blur" }],
                    applicableGender: [{ required: true, message: "请选择", trigger: "blur" }],
                },
                // icon
                iconloading: false,//icon上传Loading
                imgLoading: false,
                // banner
                bannerloading: false,
                bimgLoading: false,
                baseURL: process.env.VUE_APP_API_BASE_URL + Apis.File.upload + "?filePath=content/game/evaluation",
                // 图片上传请求请求头
                headers: {
                    Authorization: ""
                },
                subLoading: false,
                currentId: this.$store.getters["content/getEvaluationGameInfo"]().id,//当前游戏id
                contentDetail: {}, //内容详情
                disenabled: false,
                contentVersionId: '',
                hardwareList:[
                    // {id:1,name:'鼠标'},
                    // {id:2,name:'键盘'},
                    {id:4,name:'耳机'},
                    {id:8,name:'麦克风'},
                    // {id:16,name:'触屏'},
                    {id:32,name:'陀螺仪'}
                ],//设备

                tags: [],
                inputVisible: false,
                inputValue: '',
            };
        },
        created() {
            let token = localStorage.getItem("token");
            this.headers.Authorization = "Bearer " + token;
            if (this.$store.getters["content/getEvaluationGameInfo"]()) {
                this.getDetailByid()
            }
            this.form.classifyTag = this.$route.query.classifyTag
            console.log(this.form.classifyTag);
        },
        methods: {
            changeIcon(info) {
                console.log(info)
                if (info.fileList[0].response) {
                    this.form.icon = info.fileList[0].response.data;
                }
                if (info.file.status === "uploading") {
                    this.iconloading = true;
                    this.imgLoading = true;
                    return;
                }
                if (info.file.status === "done") {
                    getBase64(info.file.originFileObj, imageUrl => {
                        this.form.icon = info.file.response.data;
                        this.iconloading = false;
                        this.imgLoading = false;
                        this.$refs.addForm.validateField("icon");
                    });
                }
            },
            beforeIcon(file) {
                const isJpgOrPng =
                    file.type === "image/jpeg" || file.type === "image/png";
                if (!isJpgOrPng) {
                    this.$message.error("请上传jpg或者png图片!");
                }
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error("图片大小不能超过2M!");
                }
                return isJpgOrPng && isLt2M;
            },
            changeBanner(info) {
                if (info.fileList[0].response) {
                    this.form.coverPlanUri = info.fileList[0].response.data;
                }
                if (info.file.status === "uploading") {
                    this.bannerloading = true;
                    this.bimgLoading = true;
                    return;
                }
                if (info.file.status === "done") {
                    getBase64(info.file.originFileObj, imageUrl => {
                        this.form.coverPlanUri = info.file.response.data;
                        this.bannerloading = false;
                        this.bimgLoading = false;
                        this.$refs.addForm.validateField("coverPlanUri");
                    });
                }
            },
            beforeBanner(file) {
                const isJpgOrPng =
                    file.type === "image/jpeg" || file.type === "image/png";
                if (!isJpgOrPng) {
                    this.$message.error("请上传jpg或者png图片!");
                }
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error("图片大小不能超过2M!");
                }
                return isJpgOrPng && isLt2M;
            },
            // 保存按钮
            onSubmit() {
                let hardwareRequirements = 0;
                this.form.hardwareRequirements.forEach(v =>{
                    hardwareRequirements += v
                })
                this.$refs.addForm.validate(valid => {
                    if (valid) {
                        if (this.form.minAge > this.form.maxAge) {
                            this.$message.destroy();
                            this.$message.error('最大年龄应大于等于最小年龄');
                            return
                        }
                        this.subLoading = true
                        this.form.estimatedTime = this.form.minute * 60  + this.form.second
                        let params = {
                            ...this.form,
                            hardwareRequirements:hardwareRequirements
                        }
                        if (this.pagetype == "add") {
                            this.addEGamege(params);
                        } else {
                            this.editEGamege(params);
                        }
                    } else {
                    }
                });
            },
            // 添加基本信息
            addEGamege(params) {
                this.$http.addEGamege(params).then(res => {
                        this.$message.success("添加成功");
                        // 向父组件传参 修改add为edit
                        this.$emit('changeType', 'edit')
                        // sessionStorage保存新增数据的id和name
                        // sessionStorage.setItem("currentId", res.data.data.id)
                        sessionStorage.setItem("evacurrentId", res.data.data.id)
                        sessionStorage.setItem("currentName", this.form.name);
                        this.currentId = res.data.data.id
                        this.getDetailByid().then((dataItem) => {
                            this.$router.push({
                                query: {
                                    type: "edit",
                                    id: this.currentId,
                                    contentName: this.form.name,
                                    classifyTag: this.$route.query.classifyTag
                                }
                            });
                            this.$parent.currentNav = 1;
                            this.$parent?.setTitle()
                        })

                });
                this.subLoading = false
            },
            // 编辑基本信息
            editEGamege(params) {
                params.id = this.currentId
                this.$http.updataEGamege(params).then(res => {
                        this.$message.destroy();
                        // sessionStorage保存修改后数据的name
                        sessionStorage.setItem("currentName", this.form.name);
                        sessionStorage.setItem("currentEnabled", this.form.enabled);//name
                        this.$emit('changeType', 'edit')
                        this.$message.success("修改成功");
                    this.subLoading = false
                },()=>{
                    this.form.enabled = !this.form.enabled
                });
            },
            // 根据id获取基本信息
            getDetailByid() {
                return new Promise((resolve, reject) => {
                    let params = {
                        id: this.currentId
                    }
                    this.$http.getDetailByid(params)
                        .then(res => {
                                let dataItem = res.data.data
                                this.contentVersionId = res.data.data.contentVersionId
                                this.contentDetail = dataItem;

                                this.form.name = dataItem.contentName;
                                for (let key in this.form) {
                                    if (typeof dataItem[key] !== "undefined" && key != 'hardwareRequirements') {
                                        this.form[key] = dataItem[key]
                                    }
                                }
                                if (!this.form.optimumAge){
                                    this.form.optimumAge = undefined;
                                }
                                if (!this.form.contentType){
                                    this.form.contentType = 1;
                                }
                                this.hardwareList.forEach(v =>{
                                    if((v.id | dataItem.hardwareRequirements) == dataItem.hardwareRequirements){
                                        this.form.hardwareRequirements.push(v.id)
                                    }
                                })
                                this.form.minute = dataItem.estimatedTime > 0 ? Math.floor(dataItem.estimatedTime / 60) : '';
                                this.form.second = dataItem.estimatedTime > 0 ? dataItem.estimatedTime % 60 : '';
                                this.form.classifyTag = dataItem.classifyTag == 0 ? '' : dataItem.classifyTag ;
                                this.tags = dataItem.suitableCourses;
                                this.$store.commit("content/setEvaluationGameInfo", {contentName: dataItem.name, ...dataItem});
                                resolve(res.data.data);

                        });
                })
            },
            // 判断是否能够修改状态
            StatusChange() {
                if (this.pagetype == 'edit') {
                    const fn = () => {
                        let formData = new FormData();
                        formData.append("id", this.currentId);
                        formData.append("enabled", this.form.enabled);
                        this.$http.contentCheckStatus(formData).then(res => {
                                this.form.enabled = !this.form.enabled

                        });
                    };
                    if (this.form.enabled){
                        this.$confirm({
                            title: `确认禁用【${this.form.name}】`,
                            content: "游戏禁用后，已配置的课程将移除该游戏且不可恢复，请谨慎操作",
                            centered: true,
                            onOk: fn
                        });
                        return
                    }
                    fn();
                }

            },


            handleClose(removedTag) {
                const tags = this.tags.filter(tag => tag !== removedTag);
                this.tags = tags;
                this.form.suitableCourses = tags
            },

            showInput() {
                this.inputVisible = true;
                this.$nextTick(function() {
                    this.$refs.input.focus();
                });
            },

            handleInputChange(e) {
                this.inputValue = e.target.value;
            },

            handleInputConfirm() {
                const inputValue = this.inputValue;
                let tags = this.tags;
                if (inputValue && tags.indexOf(inputValue) === -1) {
                    tags = [...tags, inputValue];
                }

                Object.assign(this, {
                    tags,
                    inputVisible: false,
                    inputValue: '',
                });
                this.form.suitableCourses = tags
            },
        },

    };
</script>

<style scoped>
    .baseSet {
        width: 100%;
    }
    h1 {
        font-size: 20px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 30px;
    }
    .bannerUpload >>> .ant-upload.ant-upload-select-picture-card{
        width: 166px;
        height: 61px;
    }
    .iconUpload >>> .ant-upload.ant-upload-select-picture-card{
        width: 166px;
        height: 166px;
    }
</style>
